import './ARJack.css';
import { useState } from "react";
import './Header.css';
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';

import logoBosoTokyoWebp from '../img/logo-boso-tokyo.webp';
import logoBosoTokyo from '../img/logo-boso-tokyo.png';
import logoOpenseaWebp from '../img/logo-opensea.webp';
import logoOpensea from '../img/logo-opensea.png';
import logoDiscordWebp from '../img/logo-discord.webp';
import logoDiscord from '../img/logo-discord.png';
import logoTwitterWebp from '../img/logo-twitter.webp';
import logoTwitter from '../img/logo-twitter.png';
import menuIconOpen from '../img/icons/menu-icon-open.svg';
import menuIconClose from '../img/icons/menu-icon-close.svg';

import FollowUs from '../components/FollowUs';
import Footer from './Footer';

import PrizeHero from '../img/ARJack/nft_bunner/Prize-hero.webp';
import Screenshot from '../img/ARJack/screenshot.jpg';

import BunnerBoso from '../img/ARJack/nft_bunner/boso_bunner.webp';
import BunnerYamanote from '../img/ARJack/nft_bunner/yamanote_bunner.webp';
import BunnerMad from '../img/ARJack/nft_bunner/mad_bunner.webp';
import BunnerMadmind from '../img/ARJack/nft_bunner/madmind_bunner.webp';
import BunnerGenso from '../img/ARJack/nft_bunner/genso_bunner.webp';
import BunnerIsekaimeta from '../img/ARJack/nft_bunner/isekaimeta_bunner.webp';
import BunnerMitama from '../img/ARJack/nft_bunner/mitama_bunner.webp';
import BunnerOldeus from '../img/ARJack/nft_bunner/deus_bunner.webp';
import BunnerMachina from '../img/ARJack/nft_bunner/machina_bunner.webp';
import BunnerDudu from '../img/ARJack/nft_bunner/dudu_bunner.webp';
import BunnerCryptosimeji from '../img/ARJack/nft_bunner/cryptoshimeji_banner.webp';
import BunnerKumaleon from '../img/ARJack/nft_bunner/kumaleon_bunner.webp';
import BunnerNannda from '../img/ARJack/nft_bunner/nannda_bunner.webp';
import BunnerDydx from '../img/ARJack/nft_bunner/dydx_bunner.webp';

import BunnerYamanote2 from '../img/ARJack/nft_bunner/yamanote_bunner_long.webp';
import BunnerDft from '../img/ARJack/nft_bunner/dft_bunner.webp';
import BunnerAzito from '../img/ARJack/nft_bunner/azito_bunner.webp';
import BunnerGasho from '../img/ARJack/nft_bunner/gasho_bunner.webp';
import BunnerZenogakki from '../img/ARJack/nft_bunner/zenogakki_bunner.webp';
import BunnerOwange from '../img/ARJack/nft_bunner/owange_bunner.webp';
import BunnerMachina2 from '../img/ARJack/nft_bunner/machina2_bunner.webp';
import BunnerHoshiboshi from '../img/ARJack/nft_bunner/hoshiboshi_bunner.webp';

const Header = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const Menu = () => {
        return (
            <div className="Header__menu">
                <div className="Header__logo glitchPatternInfinite05">
                    <Link to="/">
                        <picture>
                            <source type="image/webp" srcSet={logoBosoTokyoWebp} />
                            <img src={logoBosoTokyo} alt="BoSo TOKYO ロゴ" />
                        </picture>
                    </Link>
                </div>
                <div className="Header__rightContainer">
                    <nav className="Header__nav">
                        <ul>
                            <li><HashLink to="/bososcramble#About">About</HashLink></li>
                            <li><HashLink to="/bososcramble#Contents">Contents</HashLink></li>
                            <li><HashLink to="/bososcramble#Prize">Prize</HashLink></li>
                            <li><HashLink to="/bososcramble#Partnership">Partnership</HashLink></li>
                        </ul>
                    </nav>

                    <div className="Header__icon">
                        <a href="https://opensea.io/collection/bosotokyo-official" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoOpenseaWebp} />
                                <img src={logoOpensea} alt="OpenSea link" />
                            </picture>
                        </a>
                    </div>
                    <div className="Header__icon glitchPatternInfinite03">
                        <a href="https://discord.com/invite/boso-tokyo" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoDiscordWebp} />
                                <img src={logoDiscord} alt="Discord link" />
                            </picture>
                        </a>
                    </div>
                    <div className="Header__icon glitchPatternInfinite04">
                        <a href="https://twitter.com/BosoTokyo" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={logoTwitterWebp} />
                                <img src={logoTwitter} alt="Twitter link" />
                            </picture>
                        </a>
                    </div>

                    <div className="Header__menuBtn">
                        <button onClick={() => setIsModalOpen(!isModalOpen)}><img src={isModalOpen ? menuIconClose : menuIconOpen} alt="sp menu open" /></button>
                    </div>

                </div>
            </div>
        )
    }

    return (

        <>
            {isModalOpen ? (
                <header className="Header open" id="HeaderLogo">
                    <Menu />
                    <div className="Header__Modal">
                        <Menu />
                        <nav className="Header__nav--sp">
                            <ul>
                                <li><HashLink to="/bososcramble#About">About</HashLink></li>
                                <li><HashLink to="/bososcramble#Contents">Contents</HashLink></li>
                                <li><HashLink to="/bososcramble#Prize">Prize</HashLink></li>
                                <li><HashLink to="/bososcramble#Partnership">Partnership</HashLink></li>
                            </ul>
                        </nav>
                    </div>
                </header>

            ) : (
                <header className="Header" id="HeaderLogo">
                    <Menu />
                </header>
            )}
        </>

    );
}

const Prize = ({ name, prize, heroImg, hash, tweet, account }) => {

    return (
        <>
            <Header />
            <div className="ARJackPrize">
                <div className="ARJackPrize__heroImg">
                    <img src={PrizeHero} alt="hero img" />
                </div>

                <div className="ARJack__main">
                    <section className="ARJack__prize" id="Prize">
                        <div className="ARJack__sectionTitle">
                            <h2 className="ARJackPrize__h2">Prize</h2>
                            <div className="ARJackPrize__sectionBorder"></div>
                            {/* <h2 className="ARJack__h2">Prize</h2>
                            <div className="ARJack__sectionBorder"></div> */}
                        </div>

                        <div className="ARJackPrize__prizeImg">
                            <img src={heroImg} alt="hero image" />
                        </div>

                        <p className="ARJackPrize__name">{name}</p>
                        <p className="ARJackPrize__prize">{prize}</p>

                        <p className="ARJackPrize__description">以下のMISSIONを30分以内に達成することで応募が完了します。</p>
                        <p className="ARJackPrize__caution">※条件達成者の中から抽選を行い、当選者のみにTwitterからDMでご連絡させていただきます。</p>

                        <div className="ARJack__contents__stepContainer">
                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-1</h4>
                                <p className="ARJack__contents__step__text">
                                    絵柄が揃ったBOSO SLOTのスクリーンショットを撮る
                                    <br />
                                    <span className="ARJack__contents__step__text__sub">※日時と揃った絵柄が見えるように撮影してください</span></p>
                                <div className="ARJack__contents__step__img">
                                    <img src={Screenshot} alt="screenshot" />
                                </div>
                            </div>

                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-2</h4>
                                <p className="ARJack__contents__step__text">
                                    以下のツイートをLIKE & RT
                                </p>
                                <div className="ARJack__contents__step__link">
                                    <a href="https://twitter.com/BosoTokyo/status/1580409445355466753" target="_blank">LIKE & RTはこちら</a>
                                </div>
                            </div>

                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-3</h4>
                                <p className="ARJack__contents__step__text">
                                    プロジェクトの公式アカウントをフォローする
                                </p>
                                <div className="ARJack__contents__step__link">
                                    <a href={`https://twitter.com/${account}`} target="_blank">アカウントをフォロー</a>
                                </div>
                            </div>

                            <div className="ARJack__contents__step">
                                <h4 className="ARJack__contents__step__h4">STEP-4</h4>
                                <p className="ARJack__contents__step__text">
                                    以下のツイートボタンからTwitterを起動し、スロットマシーンのスクリーンショットを添付してツイートして完了

                                    <br />
                                    <span className="ARJack__contents__step__text__sub">※ツイートに含まれているハッシュタグなどは応募に必要なものになりますので、削除しないようにお願いいたします。</span>
                                </p>
                                <div className="ARJack__contents__step__link">
                                    <a href={`https://twitter.com/intent/tweet?&hashtags=${hash},BOSOSCRAMBLE&text=${tweet}`}>
                                        ツイートする
                                    </a>
                                    {/* <a href={`https://twitter.com/share?&url= &hashtags=${hash}&hashtags=BOSOSCRAMBLE&text=${tweet}`}>
                                        ツイートする
                                    </a> */}
                                    {/* <a href={`https://twitter.com/share?url= &text=I completed application to @BosoTokyo at BOSO SLOT!`}>
                                        ツイートする
                                    </a> */}
                                    {/* <a href={`https://twitter.com/share?url=https://www.bosotokyo.com/bososcramble&related=Bosotokyo&hashtags=bosonftslot&hashtags=BOSOSCRAMBLE&via=metadimensions_&text=I completed application to @BosoTokyo at BOSO SLOT!`}>
                                        ツイートする
                                    </a> */}
                                </div>
                            </div>
                        </div>

                        <p className="ARJackPrize__link">キャンペーンの詳細については<Link to="/bososcramble">コチラ</Link>をご覧ください。</p>
                    </section>
                </div>
            </div>

            <FollowUs />
            <Footer />
        </>
    );
}

const RaxPrize = ({ name, prize, heroImg }) => {

    return (
        <>
            <Header />
            <div className="ARJackPrize">
                <div className="ARJackPrize__heroImg">
                    <img src={PrizeHero} alt="hero img" />
                </div>

                <div className="ARJack__main">
                    <section className="ARJack__prize" id="Prize">
                        <div className="ARJack__sectionTitle">
                            <h2 className="ARJackPrize__h2">Prize</h2>
                            <div className="ARJackPrize__sectionBorder"></div>
                            {/* <h2 className="ARJack__h2">Prize</h2>
                            <div className="ARJack__sectionBorder"></div> */}
                        </div>

                        <div className="ARJackPrize__prizeImg">
                            <img src={heroImg} alt="hero image" />
                        </div>

                        <p className="ARJackPrize__name">{name}</p>
                        <p className="ARJackPrize__prize">{prize}</p>

                        <div className="ARJack__contents__stepContainer">

                            <div className="ARJack__contents__step">
                                <p className="ARJack__contents__step__text">
                                    以下のページから応募ください。
                                </p>
                                <div className="ARJack__contents__step__link">
                                    {/* <a href="https://gleam.io/6DlKh/wired-rax-world-100-free-nfts" target="_blank"> 応募する</a> */}
                                    <a href="https://gleam.io/GhT0r/madworld-x-boso-tokyo-scramble-shibuya" target="_blank"> 応募する</a>
                                </div>
                            </div>
                        </div>

                        <p className="ARJackPrize__link">キャンペーンの詳細については<Link to="/bososcramble">コチラ</Link>をご覧ください。</p>
                    </section>
                </div>
            </div>

            <FollowUs />
            <Footer />
        </>
    );
}

export function BosoNft() {
    return (
        <>
            <Prize name="BOSO TOKYO" prize="1 NFT FREE MINT" heroImg={BunnerBoso} account="BosoTokyo" hash="bosonftslot" tweet="I completed application to @BosoTokyo at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Bosogoods() {
    return (
        <>
            <Prize name="BOSO TOKYO" prize="30 PHYSICAL GOODS" heroImg={BunnerYamanote} account="BosoTokyo" hash="bosogoodsslot" tweet="I completed application to @BosoTokyo at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Rax() {
    return (
        <>
            <Prize name="MADMIND" prize="1 NFT FREE MINT" heroImg={BunnerMadmind} account="Madworldnft" hash="madmindslot" tweet="I completed application to @Madworldnft at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
            {/* <RaxPrize name="MADWORLD" prize="100 MYSTERY BOXES NFTS DROPPING" heroImg={BunnerMad} /> */}
        </>
    );
}
export function Genso() {
    return (
        <>
            <Prize name="GENSO" prize="RARE ITEM 20 NFT FREE MINT" heroImg={BunnerGenso} account="genso_meta" hash="gensoslot" tweet="I completed application to @genso_meta at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Isekaimeta() {
    return (
        <>
            <Prize name="ISEKAI META" prize="1 NFT FREE MINT" heroImg={BunnerIsekaimeta} account="IsekaiMeta" hash="isekaislot" tweet="I completed application to @IsekaiMeta at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Mitama() {
    return (
        <>
            <Prize name="MITAMA" prize="3 NFT FREE MINT" heroImg={BunnerMitama} account="MintMitama" hash="mitamaslot" tweet="I completed application to @MintMitama at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Oldeus() {
    return (
        <>
            <Prize name="OLDEUS" prize="10 NFT WHITE LIST" heroImg={BunnerOldeus} account="oldeusofficial" hash="oldeusslot" tweet="I completed application to @oldeusofficial at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Machina() {
    return (
        <>
            <Prize name="MACHINA" prize="1 NFT FREE MINT" heroImg={BunnerMachina} account="Machina_NFT" hash="machinaslot" tweet="I completed application to @Machina_NFT at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Dudu() {
    return (
        <>
            <Prize name="DUDU" prize="10 NFT WHITE LIST" heroImg={BunnerDudu} account="dudulabNFT" hash="duduslot" tweet="I completed application to @dudulabNFT at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Cryptosimeji() {
    return (
        <>
            <Prize name="CRYPTOSIMEJI" prize="5 NFT FREE MINT" heroImg={BunnerCryptosimeji} account="Cryptosimeji" hash="cryptosimejislot" tweet="I completed application to @Cryptosimeji at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Kumaleon() {
    return (
        <>
            <Prize name="KUMALEON" prize="1 NFT FREE MINT" heroImg={BunnerKumaleon} account="KUMALEON_" hash="kumaleonslot" tweet="I completed application to @KUMALEON_  at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Nannda() {
    return (
        <>
            <Prize name="NANNDA" prize="3 NFT FREE MINT" heroImg={BunnerNannda} account="nannda_xyz" hash="nanndaslot" tweet="I completed application to @nannda_xyz at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Dydx() {
    return (
        <>
            <Prize name="DYDX HEDGIES" prize="1 NFT FREE MINT" heroImg={BunnerDydx} account="HedgiesOfficial" hash="dydxslot" tweet="I completed application to @HedgiesOfficial at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}

// Phase2（11/1〜11/13）
// BunnerDft
// BunnerAzito
// BunnerGasho
// BunnerZenogakki 
// BunnerOwange
// BunnerMachina2
// BunnerHoshiboshi

export function BosoNft2() {
    return (
        <>
            <Prize name="BOSO TOKYO" prize="1 NFT Free Mint" heroImg={BunnerBoso} account="BosoTokyo" hash="bosonftslot2" tweet="I completed application to @BosoTokyo at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Bosogoods2() {
    return (
        <>
            <Prize name="BOSO TOKYO" prize="30 PHYSICAL GOODS" heroImg={BunnerYamanote2} account="BosoTokyo" hash="bosogoodsslot2" tweet="I completed application to @BosoTokyo at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Madworld() {
    return (
        <>
            <Prize name="MADWORLD" prize="2 NFT Free Mint" heroImg={BunnerMadmind} account="Madworldnft" hash="madmindslot2" tweet="I completed application to @Madworldnft at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Dft() {
    return (
        <>
            <Prize name="DFT" prize="1 NFT Free Mint" heroImg={BunnerDft} account="beeeee_DFT" hash="dftslot" tweet="I completed application to @beeeee_DFT at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Azito() {
    return (
        <>
            <Prize name="AZITO" prize="1 NFT Free Mint or 1 AZITO Hoodie or 3 AZITO Sticker" heroImg={BunnerAzito} account="AZITOofficial" hash="azitoslot" tweet="I completed application to @AZITOofficial at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Gasho() {
    return (
        <>
            <Prize name="GASHO 2.0" prize="XS size 2.5D art" heroImg={BunnerGasho} account="GASHO_2_0" hash="gasho2_0slot" tweet="I completed application to @GASHO_2_0 at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Zenogakki() {
    return (
        <>
            <Prize name="Project Zenogakki" prize="1 NFT Free Mint" heroImg={BunnerZenogakki} account="zenogakki" hash="zenogakkislot" tweet="I completed application to @zenogakki at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Owange() {
    return (
        <>
            <Prize name="Owange NFT" prize="10 NFT Whitelist" heroImg={BunnerOwange} account="owangenft" hash="owangeslot" tweet="I completed application to @owangenft at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Machina2() {
    return (
        <>
            <Prize name="MACHINA" prize="1 NFT Free Mint or Whitelist*Depends on the time of MACHINA NFT sale" heroImg={BunnerMachina2} account="Machina_NFT" hash="machinaslot2" tweet="I completed application to @Machina_NFT at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}
export function Hoshiboshi() {
    return (
        <>
            <Prize name="HOSHI BOSHI" prize="5 NFT Whitelist" heroImg={BunnerHoshiboshi} account="HoshiBoshiNFT" hash="hoshiboshislot" tweet="I completed application to @HoshiBoshiNFT at BOSO SLOT! https://www.bosotokyo.com/bososcramble &#64;metadimensions_" />
        </>
    );
}